import React from "react";
import { connect } from "react-redux";
import { Helmet } from "react-helmet";

import Header from "components/organisms/header/index.jsx";
import Modal from "components/organisms/modal/index.jsx";
import Loader from "components/atoms/loader/index.jsx";
import ArrowLink from "components/atoms/arrowLink/index.jsx";
import Footer from "components/organisms/footer/index.jsx";
import Breadcrumbs from "components/molecules/breadcrumbs/index.jsx";
import VehicleDetail from "components/organisms/vehicleDetail/index.jsx";
import VehicleGallery from "components/organisms/vehicleGallery/index.jsx";
import { fetchStockItem } from "actions/stock";

import "./styles.scss";

class Detail extends React.Component {
  constructor(props) {
    super(props);

    this.props.fetch(props.match.params.id);
  }

  render() {
    const { vehicle } = this.props;

    if (vehicle === undefined) {
      return (
        <div>
          <Header />
          <Loader />
          <Footer />
        </div>
      );
    } else if (vehicle === null) {
      return (
        <div>
          <Helmet>
            <title>Vehículo no disponible - Territorio Yacopini</title>
            <meta
              name="description"
              content="Autos usados de Territorio Yacopini"
            />
          </Helmet>
          <Header />
          <div className="noVehicle">
            <div className="container">
              <div className="col">
                <h2>No hay nada aquí</h2>
                <p className="b">
                  {" "}
                  Lo sentimos, el vehíclo que buscas no existe o ya ha sido
                  vendido. Pero no te preocupes, tenemos muchos autos más.
                </p>
                <br />
                <p className="m">
                  <ArrowLink href="/">Seguir Buscando</ArrowLink>
                </p>
              </div>
            </div>
          </div>
          <Footer seals />
        </div>
      );
    }

    return (
      <div>
        <Helmet>
          <title>
            {vehicle.brand} {vehicle.name} {vehicle.year} usado - Territorio
            Yacopini
          </title>
          <meta
            name="description"
            content={`${vehicle.brand} ${vehicle.name} ${vehicle.year} usado - Territorio Yacopini `}
          />
        </Helmet>
        <Header />
        <Breadcrumbs vehicle={this.props.vehicle} />
        <VehicleDetail
          vehicle={this.props.vehicle}
          availablePromotion={this.props.promotion}
        />
        <VehicleGallery vehicle={this.props.vehicle} />
        <Footer seals />
        <Modal open={false} image={this.props.vehicle.images[0]} />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    vehicle: state.stock.item,
    promotion: state.stock.promotionCode,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetch: (id) => {
      dispatch(fetchStockItem(id));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Detail);
